import { useEffect, useState } from 'react';
import { findAddressPoint } from '@components/GoogleMap';

const DEFAULT_DELAY_MS = 600;

export const useAddressPoint = (query, delay = DEFAULT_DELAY_MS) => {
    const [resolved, setResolved] = useState(null);

    useEffect(() => {
        if (!query) {
            setResolved(null);
            return undefined;
        }
        let cancelled = false;
        const timer = setTimeout(async () => {
            const point = await findAddressPoint(query);
            if (!cancelled) setResolved({ query, point });
        }, delay);
        return () => {
            cancelled = true;
            clearTimeout(timer);
        };
    }, [query, delay]);

    const isCurrent = resolved?.query === query;

    return {
        point: isCurrent ? resolved.point : null,
        lastPoint: resolved?.point ?? null,
        isResolving: !!query && !isCurrent,
    };
};
